<div class="col">
  <div class="card card-cascade wider col-md-10 col-lg-8 col-12 ml-auto mr-auto">
    <div class="view gradient-card-header secondary-gradient">
      <h4>Update Settings</h4>
    </div>
    <div class="card-body">
      <p class="alert alert-danger" *ngIf="!loaded">Loading settings</p>
      <div class="form-horizontal" *ngIf="loaded">
        <div class="form-group">
          <input class="form-control" id="sendAssessmentsCompleteNotifications" type="checkbox"
            [(ngModel)]="Company.sendAssessmentsCompleteNotifications" /> <label
            for="sendAssessmentsCompleteNotifications">Send Email Notifications When Client Completes All
            Assignments</label>
        </div>
        <div class="form-group">
          <input class="form-control" id="sendNotificationsToPrimaryContact" type="checkbox"
            [(ngModel)]="Company.sendNotificationsToPrimaryContact" /> <label
            for="sendNotificationsToPrimaryContact">Send all
            Notifications to Primary Account Holder</label>
        </div>
        <div class="form-group" *ngIf="Company.sendNotificationsToPrimaryContact">
          <input class="form-control" id="sendNotificationsCopyToRegularUsers" type="checkbox"
            [(ngModel)]="Company.sendNotificationsCopyToRegularUsers" /> <label
            for="sendNotificationsCopyToRegularUsers">
            Send notification copies to Non-Admin assigned users</label>
        </div>
        <div class="form-group">
          <input class="form-control" id="disableShopAccess" type="checkbox"
            [(ngModel)]="Company.disableShopRegisteredUsers" /> <label for="disableShopAccess">Disable shop access from
            everyone except administrators</label>
        </div>
        <div class="form-group text-center">
          <div class="col-sm-12">
            <input [disabled]="isSaving" class="btn btn-primary" type="button" value="Save" (click)="save()" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/account-owner-settings/account-owner-settings.component.html